import styled from 'styled-components';

export const FiltersContainer = styled.div`
  width: 97%;
  position: relative;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem 0;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
  }
`;

export const FilterInputContainer = styled.div`
  text-align: start;

  & > h4 {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  .input-helpers__selected-options {
    text-overflow: ellipsis;
  }
`;

export const SearchAndActionsBlock = styled.div`
  width: 100%;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;

  & > .actions {
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-start;

    & > button:first-child {
      margin-right: 0.5rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: unset;

    & > .search-input {
      margin-right: 1.5rem;
    }

    & > .actions {
      width: unset;
      margin-top: unset;
    }
  }
`;
